import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { handleActions } from 'redux-actions';
import { markEditorFocused, markEditorInactive } from './actionCreators';
import { reduxKey } from './constants';
const actionHandlers = handleActions({
    [markEditorFocused.toString()]: (state, { payload  })=>payload ? _object_spread_props(_object_spread({}, state), {
            [payload.editorKey]: {
                isActive: true
            }
        }) : state,
    [markEditorInactive.toString()]: (state, { payload  })=>payload ? _object_spread_props(_object_spread({}, state), {
            [payload.editorKey]: {
                isActive: false
            }
        }) : state
}, {});
export default {
    [reduxKey]: actionHandlers
};
